<template>
  <div class="service-content">
    <h1>用户协议</h1>
    <p>
      本《用户协议》（以下简称“协议”）是您（以下简称“用户”）与跳绳裁判助手应用（以下简称“本APP”或“我们”）之间的法律协议，适用于您对本APP的使用。使用本APP之前，请仔细阅读以下条款。使用本APP即表示您同意遵守本协议的所有条款和条件。
    </p>

    <h2>1. 用户资格</h2>
    <p>
      本APP仅提供给跳绳裁判及相关赛事组织者使用。用户必须年满18周岁并具备完全民事行为能力，或者在监护人的监护下使用本APP。
    </p>

    <h2>2. 服务内容</h2>
    <p>
      本APP提供跳绳赛事中的打分和评分辅助功能，帮助裁判对参赛选手的表现进行公正、公平的评分。我们提供以下主要功能：
    </p>
    <ul>
      <li>实时评分</li>
      <li>数据统计与分析</li>
      <li>历史评分记录</li>
    </ul>

    <h2>3. 用户责任</h2>
    <p>
      用户在使用本APP时需遵守相关法律法规和比赛规则，不得利用本APP进行任何违法、违规或损害其他用户利益的行为。用户承诺提供的评分数据为真实、准确，并自行承担因使用本APP所产生的责任。
    </p>

    <h2>4. 知识产权</h2>
    <p>
      本APP中所有内容（包括但不限于代码、设计、图标、文档等）均为我们所有或授权使用，受相关知识产权法律的保护。未经许可，用户不得对本APP进行复制、修改、分发或进行其他侵犯知识产权的行为。
    </p>

    <h2>5. 数据隐私</h2>
    <p>
      我们致力于保护用户的个人隐私信息，用户在使用本APP时产生的所有评分数据将仅用于赛事分析和评分目的，不会被用于其他商业用途或泄露给未经授权的第三方。
    </p>

    <h2>6. 免责声明</h2>
    <p>
      本APP为赛事评分工具，评分数据的准确性由用户自行负责。我们不对因系统故障、网络问题或其他不可抗力事件造成的数据丢失、错误或其他后果承担责任。
    </p>

    <h2>7. 修改与终止</h2>
    <p>
      我们有权随时修改本协议内容，修改后的协议将在APP内公布并立即生效。用户继续使用本APP即视为同意修改后的协议条款。我们保留在任何时候终止或暂停用户使用本APP的权利。
    </p>

    <h2>8. 适用法律</h2>
    <p>
      本协议受中华人民共和国法律管辖，若发生任何争议，双方应协商解决，协商不成的，任何一方可向APP所在地有管辖权的人民法院提起诉讼。
    </p>

    <h2>9. 联系我们</h2>
    <p>
      如果您对本协议有任何疑问或建议，请随时通过developadmin@ijustjump.com与我们联系。
    </p>
  </div>
</template>

<script>
export default {
  name: 'ServiceView',
};
</script>

<style scoped>
.service-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  font-family: 'Arial', sans-serif;
  color: #333;
}

h1, h2 {
  font-size: 28px;
  font-weight: bold;
  margin-top: 20px;
}

p {
  font-size: 16px;
  margin-bottom: 15px;
}

ul {
  padding-left: 20px;
  list-style-type: disc;
}

li {
  margin-bottom: 10px;
}
</style>